import React, { memo } from 'react'
import { Grid, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import DashboardCard from '../shared/DashboardCard/DashboardCard'
import DownloadButton from '../shared/inputs/DownloadButton'
import DataTable from '../shared/DataTable/DataTable'
import TransactionDataRow from '../shared/TransactionDataRow/TransactionDataRow'

const TransactionsData = ({
  t,
  transactionsTableProps: {
    transactionsProfile,
    onChangeTransactionsPage,
    transactionsHeaders,
    onDownloadTransactionsReport,
    onTransactionsPerPageChange,
    transactionsDownloadProfile: { isProcessing }
  },
  currentTokenId,
  currentBrandId,
  customTittle,
  showTxnForExchange
}) => {
  const theme = useTheme()
  const { transactions, pagination } = transactionsProfile
  const txTableData = transactions.map((transaction, index) => (
    <DataTableRow
      key={index}
      currentTokenId={currentTokenId}
      currentBrandId={currentBrandId}
      {...transaction}
      t={t}
      theme={theme}
      showTxnForExchange={showTxnForExchange}
    />
  ))
  return (
    <DashboardCard
      title={customTittle || t('analytics.transactions-tx')}
      action={
        <Grid container spacing={2} justifyContent='flex-end'>
          <Grid item>
            <DownloadButton
              label={t('transactions.download-csv')}
              onClick={onDownloadTransactionsReport}
              disabled={transactions.length === 0 || isProcessing}
            />
          </Grid>
        </Grid>
      }
      noPadding
    >
      <DataTable
        headers={transactionsHeaders}
        data={txTableData}
        onChangePage={onChangeTransactionsPage}
        onRowsPerPageChange={onTransactionsPerPageChange}
        pagination={pagination}
        size='small'
        t={t}
        noRecordsMessage={t('transactions.no-transactions-found')}
      />
    </DashboardCard>
  )
}

export default memo(TransactionsData)

const DataTableRow = (props) => {
  return (
    <TableRow hover>
      <TransactionDataRow {...props} showUserDetails />
    </TableRow>
  )
}
